// apps/accounts/src/layouts/StaffLayout.jsx
import React, { useState, useEffect } from 'react';
import { Outlet, Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { StaffSidebar } from '../components/StaffSidebar';
import { TopBar } from '../components/TopBar';

export const StaffLayout = () => {
  const { isAuthenticated, loading, user } = useAuth();
  const location = useLocation();
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  // Close sidebar on route change (mobile)
  useEffect(() => {
    if (window.innerWidth < 1024) setIsSidebarOpen(false);
  }, [location]);

  // Handle resize
  useEffect(() => {
    const handleResize = () => {
      setIsSidebarOpen(window.innerWidth >= 1024);
    };
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const toggleSidebar = () => setIsSidebarOpen(prev => !prev);

  if (loading) return <div className="flex justify-center items-center h-screen">Loading...</div>;
  if (!isAuthenticated) return <Navigate to="/login" replace />;
  if (user?.role !== 'site_staff') return <Navigate to="/dashboard/main" replace />;

  return (
    <div className="flex flex-col h-screen overflow-hidden bg-slate-50">
      <TopBar onToggleSidebar={toggleSidebar} isSidebarOpen={isSidebarOpen} />
      <div className="flex flex-1 overflow-hidden relative">
        {/* Sidebar */}
        <div className={`
          fixed inset-y-0 left-0 z-40 w-64 bg-slate-900 shadow-lg transition-transform duration-300
          lg:relative lg:translate-x-0 lg:shadow-none
          ${isSidebarOpen ? 'translate-x-0' : '-translate-x-full'}
        `}>
          <StaffSidebar />
        </div>

        {/* Overlay */}
        {isSidebarOpen && (
          <div className="fixed inset-0 z-30 bg-black/50 lg:hidden" onClick={toggleSidebar} />
        )}

        <main className="flex-1 overflow-y-auto p-6 bg-slate-50/50">
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default StaffLayout;